<div class="loader-screen">
    <img src="assets/images/logo/logo.svg" alt="">
    <div class="spinner">
        <div class="bounce1 bg-primary"></div>
        <div class="bounce2 bg-primary"></div>
        <div class="bounce3 bg-primary"></div>
    </div>
</div>
